import { useOutletContext } from "react-router-dom";
import { IntegrationShell } from "../common/Shell";
import PineConeComponent from "V2.0/HomePages/HomeModule/PineConeComponent";

export function PineConeIntegration() {
  const { projectId, settings, fetchSettings, isViewOnly } = useOutletContext();

  return (
    <IntegrationShell>
      <PineConeComponent
        projectId={projectId}
        settings={settings}
        fetchSettings={fetchSettings}
        isViewOnly={isViewOnly}
      />
    </IntegrationShell>
  );
}
